import anime from 'animejs/lib/anime.es.js';

export function loadAnimationFunc() {
    //ローディングアニメーション
    let loaderBg = $('#loaderBg').length;
    
    if (loaderBg) {
        //$('#loaderBg').delay(500).fadeOut(700);
        let images = document.getElementsByTagName('img');
        let loadingBar = document.getElementById('loading_bar');
        let imgLen = images.length;
        let barLen = 100 / imgLen;
        let barWidth = 0;

        for (var i = 0; i < imgLen; i++) {
            images[i].onload = function () {
                barWidth = barWidth + barLen;
                loadingBar.style.width = barWidth + '%';
            }
        }

        let loaderClose = function loaderClose() {
            $('#loaderBg').delay(1200).fadeOut(700); //10秒たっても消えない時用

            loadingBar.style.width = '100%';
        }
        setTimeout(loaderClose, 1000);
    }
}

export function anniversarySlideFunc() {
    let anniversarySlide = $('#anniversarySlide').length;
    
    if (anniversarySlide) {
        
        let slide = $('#anniversarySlide');
        let mainKvHeight = $('#firstColumn').outerHeight();
        let clone03Height = $('#clone03 img').outerHeight();
        slide.outerHeight(mainKvHeight);
        //$('#clone03').outerHeight(clone03Height);
  }
}

export function anniversarySlideCloneFunc() {
    let anniversarySlide = $('#anniversarySlide').length;
    
    if (anniversarySlide) {
//        $('#clone01').clone(true).insertAfter('#clone01');
//        $('#clone02').clone(true).insertAfter('#clone02');
//        $('#clone03').clone(true).insertAfter('#clone03');
//        $('#clone04').clone(true).insertAfter('#clone04');
  }
}

export function anniversaryScrollFunc() {
    let anniversaryIndex = $('#anniversaryIndex').length;
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))
    let scrollAnimationFlag01 = false;
    let scrollAnimationFlag02 = false;
    let scrollAnimationFlag03 = false;
    let scrollAnimationFlag04 = false;
    let scrollAnimationFlag05 = false;
    let scrollAnimationFlag06 = false;
    let scrollAnimationFlag07 = false;
    let scrollAnimationFlag08 = false;
    let scrollAnimationFlag09 = false;
    
    const breakPoint = 768;
    
    let num;
    
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    
    if (anniversaryIndex) {
        
        if (breakPoint < window.innerWidth) {
            num = 300;
        } else {
            num = 50;
        }
        
        $('.about .aboutTitArea').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag01) {
                    scrollAnimationFlag01 = true;

                    wait(0)
                        .then(() => {
                            $('.aboutTitArea').addClass('active');
                            return wait(500)
                        })
                        .then(() => {
                            $('.aboutTitArea .gradationLine').addClass('active');
                            return wait(500)
                        })

                }
            }
        });
        $('.about .clearFix').each(function () {
            var position = $(this).offset().top;
            let Kvpos =  $('.aboutTitArea').offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag02) {
                    scrollAnimationFlag02 = true;

                    wait(0)
                        .then(() => {
                            $('.aboutImg').addClass('active');
                            return wait(500)
                        })
                        .then(() => {
                            $('.aboutTxt').addClass('active');
                            return wait(500)
                        })
                }
            }
            
//            if (Kvpos < scroll < position - windowHeight + 500) {
//                $('.aboutTxt02').removeClass('active');
//                $('.aboutTxt01').addClass('active');
//            }
//            if (scroll > position - windowHeight + 500) {
//                $('.aboutTxt01').removeClass('active');
//                $('.aboutTxt02').addClass('active');
//            }
        });
        
        $('.history .historyTxtBox').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag03) {
                    scrollAnimationFlag03 = true;
                    
                    $('.historySubTit').addClass('active');
                    $('.historyTxt').addClass('active');
                    $('.btnWhite').addClass('active');

                }
            }
        });
        
        $('.interviewTit').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag08) {
                    scrollAnimationFlag08 = true;
                    
                    $(this).addClass('active');

                }
            }
        });
        
        $('.interview .interviewBox01').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag04) {
                    scrollAnimationFlag04 = true;
                    
                    $('.interviewBox01 .imgBox').addClass('active');
                    $('.interviewBox01 .name').addClass('active');
                    $('.interviewBox01 .post').addClass('active');

                }
            }
        });
        $('.interview .interviewBox02').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag05) {
                    scrollAnimationFlag05 = true;
                    
                    $('.interviewBox02 .imgBox').addClass('active');
                    $('.interviewBox02 .name').addClass('active');
                    $('.interviewBox02 .post').addClass('active');
                    
                }
            }
        });
        
        $('.crossTalkTit').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag09) {
                    scrollAnimationFlag09 = true;
                    
                    $(this).addClass('active');

                }
            }
        });
        
        $('.crossTalk .crossTalkBox').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag06) {
                    scrollAnimationFlag06 = true;

                    wait(0)
                        .then(() => {
                            $('.img01').addClass('active');
                            return wait(300)
                        })
                        .then(() => {
                            $('.img02').addClass('active');
                            return wait(300)
                        })
                        .then(() => {
                            $('.img03').addClass('active');
                            return wait(300)
                        })
                        .then(() => {
                            $('.img04').addClass('active');
                            $('.drawTxt').addClass('active');
                            return wait(300)
                        }).then(() => {
                            $('.img05').addClass('active');
                            return wait(100)
                        })

                }
            }
        });
        
        $('.bottomMessage').each(function () {
            var position = $(this).offset().top;

            if (scroll > position - windowHeight + num) {
                if (!scrollAnimationFlag07) {
                    scrollAnimationFlag07 = true;

                    wait(0)
                        .then(() => {
                            $('.bottomMessageTitPc').addClass('active');
                            return wait(300)
                        })
                        .then(() => {
                            // 一文字ずつフェードインさせる
                            $('.bottomMessageSubTit').css({
                                'opacity': 1
                            });
                            for (var i = 0; i <= $('.bottomMessageSubTit').children().length; i++) {
                                $('.bottomMessageSubTit').children('span:eq(' + i + ')').delay(60 * i).animate({
                                    'opacity': 1
                                }, 20);
                            };
                            return wait(2200)
                        })
                        .then(() => {
                            $('.bottomMessage .gradationLine').addClass('active');
                            return wait(300)
                        })
                        .then(() => {
                            $('.bottomMessageTxt').addClass('active');
                            return wait(300)
                        })
                        .then(() => {
                            $('.bottomMessageTitSp').addClass('active');
                            return wait(300)
                        })
                }
            }
        });
    }
}